import { render } from "./ChangePassword.vue?vue&type=template&id=8cfea606&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=8cfea606&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8cfea606"

export default script